// React
import React from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from '../../../actions';

// Custom
import { ActionButton } from "../Buttons/ActionButton";
import {CancelButton} from "../Buttons/CancelButton";
import { ErrorMessage } from "../ErrorMessage";

// Utilities
import { required, isEmail, composeValidators, isNum, passwordsMustMatch } from '../validation';

// Forms
import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import { TextFieldAdapter } from '../TextFieldAdapter';

// Styled Components
import { FormIcon } from '../FormIcon';
import { FormGroup } from '../StyledComponents/FormGroup';
import { HiddenLabel } from '../StyledComponents/HiddenLabel';
import TextButton from 'components/Button/TextButton';
import AuthFormFooter from 'components/Form/AuthFormFooter';



import { constants } from '../../../constants';

const LoginStep = props => {
    const { handleClose, errorData, startLogin, errors, resetErrors, stepperControls, handleChooseAuthDialog, loginOnly = false } = props;
    const { reverseStepper, advanceStepper } = stepperControls;
    
    const handleLogin = values => {
        startLogin('password', values.email, values.password)
            .then((user) => {
                console.log('User logged in:', user);
                if(loginOnly){
                    handleClose();
                    if (props.emailVerified) {
                        props.notifyUser({
                            message: 'Welcome, you are now logged in.',
                            textColor: 'white'
                        });
                    }
                } else {
                    advanceStepper();
                }
            })
            .catch((error)=>{
                return { [FORM_ERROR]: "Login Failed" };
            });
            return;
    }

    return (
        <div style={ styles.containerStyles } label="Log In">
            <h3 style={ styles.titleStyles }>
                GET STARTED
            </h3>
            <p style={ styles.descriptionStyles }>
                Enter your email and password to access your Cyno account.
            </p>
            <Form
                onSubmit={handleLogin}
                render={({ handleSubmit, reset, submitting, pristine, values, invalid }) => {
                    return (
                    <form id="authForm" style={{display: 'flex', flexFlow: 'column nowrap'}} onSubmit={handleSubmit}>
                        <FormGroup>
                            <HiddenLabel>Email</HiddenLabel>
                            <Field
                                name="email"
                                component={TextFieldAdapter}
                                type="text"
                                placeholder="Email"
                                validate={isEmail}
                                icon="envelope"
                                data-testid="email-input"
                            />
                        </FormGroup>
                        
                        <FormGroup>
                            <HiddenLabel>Password</HiddenLabel>
                            <Field
                                name="password"
                                component={TextFieldAdapter}
                                type="password"
                                placeholder="Password"
                                validate={required}
                                icon="lock"
                                data-testid="password-input"
                            />
                        </FormGroup>
                        
                        { errors && <ErrorMessage errors={errors} />}

                        <ActionButton 
                            options={{
                                label: 'Log In',
                                form: 'authForm',
                                action: (event)=>{
                                    handleSubmit(event);
                                    props.clearAuthErrors();
                                },
                                disabled: invalid || pristine
                            }} 
                            // userId={props.userId}
                            advanceStepper={advanceStepper}
                        />

                        <TextButton onClick={
                            (event) => {
                                handleChooseAuthDialog('reset');
                                    resetErrors(reset);
                                    props.clearAuthErrors();
                            }}
                        >
                            <h2 style={{ display: 'flex', color: '#379DA8', fontSize: 14, textDecoration: 'underline', paddingTop: 8}}>
                                Forgot Password?
                            </h2>
                        </TextButton>
                        {/* { !props.hideSignUp &&
                            <AuthFormFooter>
                                <h2 style={{ display: 'flex', color: 'rgba(0,0,0,0.6)', fontSize: 14,}}>
                                    Don't have an account?
                                </h2>
                                <TextButton 
                                    onClick={
                                        (event)=>{
                                            resetErrors(reset);
                                            props.clearAuthErrors();
                                            handleChooseAuthDialog('signup');
                                        }
                                    }
                                >
                                    <h2 style={{ display: 'flex', color: '#379DA8', fontSize: 14,}}>
                                        Sign up
                                    </h2>
                                </TextButton>
                            </AuthFormFooter>
                        } */}
                        {/*
                            <CancelButton handleClose={handleClose} reset={reset} clearAuthErros={ props.clearAuthErrors } resetErrors={resetErrors} />
                        */}
                    </form>
                )}}
            />
        </div>
    );
}

const mapStateToProps = ({auth}) => {
    return {
        emailVerified: auth.authData.emailVerified,
    };
};

export const LoginStepDisconnected = LoginStep;

export default connect(mapStateToProps, actions)(LoginStep);

const styles = {
    containerStyles: {
        fontSize: constants.text.baseFontStyles.fontSize
    },
    descriptionStyles: {
        color: 'rgba(0,0,0,0.4)', 
        fontSize: 13,
        marginTop: -20, 
    },
    titleStyles: {
        marginTop: 0
    },
}


// WEBPACK FOOTER //
// ./src/js/components/Form/Steps/LoginStep.jsx